import React from "react";
import "./Invite.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
function Invite() {
  const navigate = useNavigate();
  return (
    <>
      <section className="Invite">
        <Common_white_header headingText={"Invite"} />
        <div className="container">
          <div className="text_hodler">
            <p>Please Swipe left-right to choose your favorite poster</p>
          </div>

          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1.2}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000 }}
            loop={true}
            className="Invite_swiper common_swiper"
            centeredSlides={true}
          >
            {/* Slide 1 */}
            <SwiperSlide>
              <div className="img_holder">
                <img
                  src="/assets/images/Invite/Invite_banner/img_1.png"
                  alt="banner img"
                  className="banner_img"
                />
              </div>
            </SwiperSlide>

            {/* Slide 2 */}
            <SwiperSlide>
              <div className="img_holder">
                <img
                  src="/assets/images/Invite/Invite_banner/img_2.png"
                  alt="banner img"
                  className="banner_img"
                />
              </div>
            </SwiperSlide>

            {/* Slide 3 */}
            <SwiperSlide>
              <div className="img_holder">
                <img
                  src="/assets/images/Invite/Invite_banner/img_3.png"
                  alt="banner img"
                  className="banner_img"
                />
              </div>
            </SwiperSlide>
          </Swiper>

          <div className="invite_text_holder">
           <p>Invite Friends</p>
           <p>Income <span> 10 Billions </span> Commission</p>
          </div>

          <div className="btn_holder">
            <Button
              className="btn_register_bg mb-3"
              onClick={() => navigate("/home")}
            >
              Download QR code
            </Button>
            <Button
              className="btn-register  mb-3"
              onClick={() => navigate("/home")}
            >
              Copy invitation Link
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}

export default Invite;
